"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ArrowButton_1 = __importDefault(require("./ArrowButton"));
const EmblemLogo_1 = __importDefault(require("./logos/EmblemLogo"));
const IdHeader = (props) => {
    const [backLink, setBackLink] = react_1.default.useState("");
    react_1.default.useEffect(() => {
        if (!!window.ReactNativeWebView &&
            document.getElementById("react-token")) {
            let token = document
                .getElementById("react-token")
                .getAttribute("token");
            window.ReactNativeWebView.postMessage(token);
        }
        if (document.getElementById("react-data")) {
            try {
                let data = document
                    .getElementById("react-data")
                    .getAttribute("encoded");
                let parsed_data = JSON.parse(data);
                if (parsed_data.backUrl) {
                    setBackLink(parsed_data.backUrl);
                }
            }
            catch (error) { }
        }
    }, []);
    return (react_1.default.createElement("header", { className: "idheader" },
        react_1.default.createElement("div", { className: "idheader__content" },
            react_1.default.createElement("div", { className: "idheader__button" }, !props.hideBackButton && backLink != "" ? (react_1.default.createElement(ArrowButton_1.default, { label: "Back", direction: "left", handlerFunction: function () {
                    window.location.href = backLink;
                } })) : null),
            react_1.default.createElement(EmblemLogo_1.default, { size: "24", color: "light50" }))));
};
exports.default = IdHeader;
